import React, {useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import RouteKey from '../../routes/key';
import {BaseRole} from '../DefaultHeader';
import MenuCollapseItem from '../MenuCollapseItem';
import AccountsMenuItem from './components/AccountsMenuItem';
import PersonalMenuItem from './components/PersonalMenuItem';
import SettingMenuItem from './components/SettingMenuItem';
import {useMenu} from './DesktopMenu';

const {
  result,
  resit,
  exam,
  admin,
  appeal,
  accessArrangement,
  withdrawal,
  amendment,
  specialConsideration: special,
  usefulInformation: usefulInformationCandidate,
  statementOfResults,
  transaction,
} = RouteKey.child;

const {
  candidate: transactionCandidate,
  coordinator: transactionCoordinator,
} = RouteKey.transaction.child;

const applyResitId = 'apply-for-resit';
const registeredExamsLabel = 'Registered Exams';
const appealForResults = 'Appeal for Review of Results';
const {candidate: transactionRoot} = RouteKey.transaction.child;

const {
  orgAdminResultRelease,
  transactionLog,
  oopAdminResitApply,
  oopAdminResitRegisteredExam,
  opAdminRegistrationReport,
  opAdminResultsAppeal,
  opAdminPaymentReport,
  uniqueLink,
  withdrawalLink,
  specialConsideration,
  nationalReport,
  nonNationalReport,
  nonNationalExamApplication,
  usefulInformation,
  oopAdminResultAppealAccess,
  specialConsiderationReport,
  opsAdminAccessArrangementReport,
  orgAdminNonNationalResult,
  manageAnnouncements,
  manageNotifications,
  auditReport,
  dataArchivalReport,
  notificationReport,
  profileAmendmentRequests,
  jobStatusReport,
} = RouteKey.admin.child;

const {coordinatorResultList, myExaminations} = RouteKey.result.child;
const {listing, coordinatorListing, instruction, coordinatorResitRegister} = RouteKey.resit.child;
const {applications, importantNotes, applicationsCoordinator} = RouteKey.appeal.child;
const {
  examRegistrations,
  registerExam,
  coordinatorRegisterExam,
  coordinatorExamRegistrations,
  coordinatorEntryProofs,
  nonNationalExaminations,
} = RouteKey.exam.child;

const {root: accessArrangementRoot, coordinatorRoot: accessArrangementCoordinatorRoot} = RouteKey[
    'access-arrangement'
    ].child;

const {withdrawal: coordinatorWithdrawal} = RouteKey.withdrawal.child;

const {
  coordinatorExamRegistrations: coordinatorAmendmentExamRegistrations,
} = RouteKey.amendment.child;

const candidateResitPathDetails = [
  `/${resit}/${instruction.route}`,
  `/${exam}/${examRegistrations.route}/${registerExam.route}`,
];
const candidateRegisterPathDetails = [
  `/${resit}/${listing.route}`,
  `/${usefulInformationCandidate}`,
];
const candidateAppealPathDetails = [`/${appeal}/${importantNotes.route}`];
const candidateResultsPathDetails = [`/${result}/${myExaminations.route}`];

const {root: statementOfResultsRoot} = RouteKey['statement-of-results'].child;

const coordinatorResitPathDetails = [`/${resit}/${coordinatorResitRegister.route}`];
const coordinatorRegisterPathDetails = [
  `/${resit}/${coordinatorListing.route}`,
  `/${exam}/${coordinatorExamRegistrations.route}`,
];
const coordinatorResultsPathDetails = [`/${result}/${coordinatorResultList.route}`];
const coordinatorMakingRequestPathDetails = [
  `/${withdrawal}/${coordinatorWithdrawal.route}`,
  `/${amendment}/${coordinatorAmendmentExamRegistrations.route}`,
];

const adminApplicationsPathDetails = [
  `/${admin}/${orgAdminResultRelease.route}`,
  `/${admin}/${oopAdminResitApply.route}`,
  `/${admin}/${uniqueLink.route}`,
  `/${admin}/${usefulInformation.route}`,
];
const adminReportsPathDetails = [
  `/${admin}/${transactionLog.route}`,
  `/${admin}/${oopAdminResitRegisteredExam.route}`,
  `/${admin}/${opAdminResultsAppeal.route}`,
  `/${admin}/${opAdminPaymentReport.route}`,
  `/${admin}/${opsAdminAccessArrangementReport.route}`,
  `/${admin}/${specialConsiderationReport.route}`,
  `/${admin}/${jobStatusReport.route}`,
];

export interface UseCollapseReturn {
  anchorEl: any;
  handleClick: (event: any) => void;
  handleClose: () => void;
}

export const useCollapse = (): UseCollapseReturn => {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    handleClick,
    handleClose,
  };
};

const registerForExamGceId = 'register-for-exam-gce';
const registerForExamAeisId = 'register-for-exam-aeis';
const registerForExamSAeisId = 'register-for-exam-s-aeis';
const registerForExamSpersId = 'register-for-exam-spers';
const registerForExamSpersSecId = 'register-for-exam-spers-sec';
const statementOfResultsId = 'statement-of-results';

const candidateApplyExamList = (
    history: any,
    checkSubMenuPathInLocation: (value: string) => boolean,
    setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
): (
    | {
  id?: string;
  idKey: string;
  label: string;
  navigate: () => void;
  isActiveSubMenu: boolean;
  isNonNationExam?: boolean;
}
    | string
    )[] => [
  'National Examinations',
  {
    id: registerForExamGceId,
    idKey: registerForExamGceId,
    label: 'GCE-Level Examination(s)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${exam}/${examRegistrations.route}/${registerExam.route}/GCE`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${exam}/${examRegistrations.route}/${registerExam.route}/GCE`
    ),
  },
  {
    id: applyResitId,
    idKey: 'resit',
    label: 'Register for Year-End MTL exam (After Mid-Year Results Release)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${resit}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${resit}/${instruction.route}`),
  },
  'Non-National Examinations',
  {
    id: registerForExamAeisId,
    idKey: registerForExamAeisId,
    label: 'Admissions Exercise for International Students (AEIS)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/aeis`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/aeis`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSAeisId,
    idKey: registerForExamSAeisId,
    label: 'Supplementary Admissions Exercise for International Students (S-AEIS)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/s-aeis`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/s-aeis`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSpersSecId,
    idKey: registerForExamSpersSecId,
    label: 'School Placement Exercise for Returning Singaporeans-Secondary (SPERS-Sec)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(
          `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spers-sec`
      );
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spers-sec`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSpersId,
    idKey: registerForExamSpersId,
    label: 'Supplementary Placement Exercise (SPE)',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spe`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spe`
    ),
    isNonNationExam: true,
  },
  '',
  {
    id: transaction,
    idKey: transaction,
    label: 'Transactions',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${transaction}/${transactionCandidate.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${transaction}/${transactionRoot.route}`),
  },
];

const CandidateMenu = ({
                         setMobileMenuOpen,
                       }: {
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {history, checkMenuPathsInLocation, checkSubMenuPathInLocation} = useMenu();

  const collapseMenuItem1 = useCollapse();
  const collapseMenuItem4 = useCollapse();
  const collapseMenuItem5 = useCollapse();
  const collapseMenuItem12 = useCollapse();

  return (
      <>
        <MenuCollapseItem
            {...collapseMenuItem1}
            handleClick={(evt) => {
              if (!collapseMenuItem1.anchorEl) {
                collapseMenuItem4.handleClose();
                collapseMenuItem5.handleClose();
                collapseMenuItem12.handleClose();
                collapseMenuItem1.handleClick(evt);
              } else {
                collapseMenuItem1.handleClose();
              }
            }}
            label="Applying for Exams"
            subMap={candidateApplyExamList(history, checkSubMenuPathInLocation, setMobileMenuOpen)}
            isActiveMenu={checkMenuPathsInLocation(candidateResitPathDetails)}
        />
        <MenuCollapseItem
            {...collapseMenuItem4}
            handleClick={(evt) => {
              if (!collapseMenuItem4.anchorEl) {
                collapseMenuItem1.handleClose();
                collapseMenuItem5.handleClose();
                collapseMenuItem12.handleClose();
                collapseMenuItem4.handleClick(evt);
              } else {
                collapseMenuItem4.handleClose();
              }
            }}
            label="Getting Ready for Exams"
            subMap={[
              {
                id: 'registered-exams',
                label: registeredExamsLabel,
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${exam}/${examRegistrations.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${exam}/${examRegistrations.route}`),
              },
              {
                id: 'useful-information',
                label: 'Useful Information',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${usefulInformationCandidate}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${usefulInformationCandidate}`),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(candidateRegisterPathDetails)}
        />
        <MenuCollapseItem
            {...collapseMenuItem5}
            handleClick={(evt) => {
              if (!collapseMenuItem5.anchorEl) {
                collapseMenuItem1.handleClose();
                collapseMenuItem4.handleClose();
                collapseMenuItem12.handleClose();
                collapseMenuItem5.handleClick(evt);
              } else {
                collapseMenuItem5.handleClose();
              }
            }}
            label="Getting Exam Results"
            subMap={[
              {
                id: 'results',
                label: 'Results',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${result}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${result}/${myExaminations.route}`),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(candidateResultsPathDetails)}
        />
        <MenuCollapseItem
            {...collapseMenuItem12}
            handleClick={(evt) => {
              evt.stopPropagation();
              if (!collapseMenuItem4.anchorEl) {
                collapseMenuItem1.handleClose();
                collapseMenuItem4.handleClose();
                collapseMenuItem5.handleClose();
                collapseMenuItem12.handleClick(evt);
              } else {
                collapseMenuItem12.handleClose();
              }
            }}
            label="Making Requests"
            subMap={[
              {
                id: 'making-requests',
                label: appealForResults,
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${appeal}/${applications.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${appeal}/${applications.route}`),
              },
              {
                id: 'access-arrangements',
                label: 'Access Arrangements',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${accessArrangement}/${accessArrangementRoot.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${accessArrangement}/${accessArrangementRoot.route}`
                ),
              },
              {
                id: 'special-consideration',
                label: 'Special Consideration',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${special}/${specialConsideration.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${special}/${specialConsideration.route}`
                ),
              },
              {
                id: statementOfResultsId,
                label: 'Statement of Results',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${statementOfResults}/${statementOfResultsRoot.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${statementOfResults}/${statementOfResultsRoot.route}`
                ),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(candidateAppealPathDetails)}
        />
      </>
  );
};

const coordinatorMakingRequestsList = (
    history: RouteComponentProps['history'],
    checkSubMenuPathInLocation: (value: string) => boolean,
    setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
) => [
  {
    id: 'group-appeal-results',
    label: appealForResults,
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${appeal}/${applicationsCoordinator.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${appeal}/${applicationsCoordinator.route}`),
  },
  {
    id: 'group-access-arrangements',
    label: 'Access Arrangements',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${accessArrangement}/${accessArrangementCoordinatorRoot.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${accessArrangement}/${accessArrangementCoordinatorRoot.route}`
    ),
  },
  {
    id: 'subjectAmendment',
    label: 'Subject Amendment',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${amendment}/${coordinatorAmendmentExamRegistrations.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${amendment}/${coordinatorAmendmentExamRegistrations.route}`
    ),
  },
  {
    id: 'withdrawal',
    label: 'Exam Withdrawal',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${withdrawal}/${coordinatorWithdrawal.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${withdrawal}/${coordinatorWithdrawal.route}`),
  },
  {
    id: 'special-consideration',
    label: 'Special Consideration',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${special}/${specialConsideration.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${special}/${specialConsideration.route}`),
  },
];

const CoordinatorMenu = ({
                           setMobileMenuOpen,
                         }: {
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {history, checkMenuPathsInLocation, checkSubMenuPathInLocation} = useMenu();

  const collapseMenuItem2 = useCollapse();
  const collapseMenuItem6 = useCollapse();
  const collapseMenuItem7 = useCollapse();
  const collapseMenuItem13 = useCollapse();

  return (
      <>
        <MenuCollapseItem
            {...collapseMenuItem2}
            handleClick={(evt) => {
              if (!collapseMenuItem2.anchorEl) {
                collapseMenuItem6.handleClose();
                collapseMenuItem7.handleClose();
                collapseMenuItem13.handleClose();
                collapseMenuItem2.handleClick(evt);
              } else {
                collapseMenuItem2.handleClose();
              }
            }}
            label="Applying for Exams"
            subMap={[
              'Register for an Exam',
              {
                id: 'register-for-exam-psle',
                label: 'Primary School Leaving Examinations (PSLE)',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(
                      `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/PSLE`
                  );
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/PSLE`
                ),
              },
              {
                id: 'register-for-exam-gce',
                label: 'GCE-Level Examination(s)',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(
                      `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/GCE`
                  );
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/GCE`
                ),
              },
              {
                id: 'register-for-exam-ipsle',
                label: 'International Primary School Examinations (iPSLE)',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(
                      `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/IPSLE`
                  );
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/IPSLE`
                ),
              },
              {
                id: applyResitId,
                label: 'Resit',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${resit}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${resit}/${instruction.route}`),
              },
              {
                id: transaction,
                label: 'Transactions',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${transaction}/${transactionCoordinator.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${transaction}/${transactionRoot.route}`),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(coordinatorResitPathDetails)}
        />
        <MenuCollapseItem
            {...collapseMenuItem6}
            handleClick={(evt) => {
              if (!collapseMenuItem6.anchorEl) {
                collapseMenuItem2.handleClose();
                collapseMenuItem7.handleClose();
                collapseMenuItem13.handleClose();
                collapseMenuItem6.handleClick(evt);
              } else {
                collapseMenuItem6.handleClose();
              }
            }}
            label="Getting Ready for Exams"
            subMap={[
              {
                id: 'registered-exams',
                label: registeredExamsLabel,
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${exam}/${coordinatorExamRegistrations.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${exam}/${coordinatorExamRegistrations.route}`
                ),
              },
              {
                id: 'entryProof',
                label: 'Entry Proof',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${exam}/${coordinatorEntryProofs.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(`/${exam}/${coordinatorEntryProofs.route}`),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(coordinatorRegisterPathDetails)}
        />
        <MenuCollapseItem
            {...collapseMenuItem7}
            handleClick={(evt) => {
              if (!collapseMenuItem7.anchorEl) {
                collapseMenuItem2.handleClose();
                collapseMenuItem6.handleClose();
                collapseMenuItem13.handleClose();
                collapseMenuItem7.handleClick(evt);
              } else {
                collapseMenuItem7.handleClose();
              }
            }}
            label="Getting Exam Results"
            subMap={[
              {
                id: 'results',
                label: 'Results',
                navigate: () => {
                  setMobileMenuOpen(false);
                  history.push(`/${result}/${coordinatorResultList.route}`);
                },
                isActiveSubMenu: checkSubMenuPathInLocation(
                    `/${result}/${coordinatorResultList.route}`
                ),
              },
            ]}
            isActiveMenu={checkMenuPathsInLocation(coordinatorResultsPathDetails)}
        />

        <MenuCollapseItem
            {...collapseMenuItem13}
            handleClick={(evt) => {
              if (!collapseMenuItem13.anchorEl) {
                collapseMenuItem2.handleClose();
                collapseMenuItem6.handleClose();
                collapseMenuItem7.handleClose();
                collapseMenuItem13.handleClick(evt);
              } else {
                collapseMenuItem13.handleClose();
              }
            }}
            label="Making Requests"
            subMap={coordinatorMakingRequestsList(
                history,
                checkSubMenuPathInLocation,
                setMobileMenuOpen
            )}
            isActiveMenu={checkMenuPathsInLocation(coordinatorMakingRequestPathDetails)}
        />
      </>
  );
};

const useAdminCollapse = () => {
  const collapseMenuItem3 = useCollapse();
  const collapseMenuItem8 = useCollapse();
  const collapseMenuItem9 = useCollapse();
  const collapseMenuItem10 = useCollapse();
  const collapseMenuItem11 = useCollapse();

  return {
    collapseMenuItem3,
    collapseMenuItem8,
    collapseMenuItem9,
    collapseMenuItem10,
    collapseMenuItem11,
    menu3Handle: (evt: any) => {
      if (!collapseMenuItem3.anchorEl) {
        collapseMenuItem8.handleClose();
        collapseMenuItem9.handleClose();
        collapseMenuItem10.handleClose();
        collapseMenuItem11.handleClose();
        collapseMenuItem3.handleClick(evt);
      } else {
        collapseMenuItem3.handleClose();
      }
    },
    menu8Handle: (evt: any) => {
      if (!collapseMenuItem8.anchorEl) {
        collapseMenuItem3.handleClose();
        collapseMenuItem9.handleClose();
        collapseMenuItem10.handleClose();
        collapseMenuItem11.handleClose();
        collapseMenuItem8.handleClick(evt);
      } else {
        collapseMenuItem8.handleClose();
      }
    },
    menu9Handle: (evt: any) => {
      if (!collapseMenuItem9.anchorEl) {
        collapseMenuItem3.handleClose();
        collapseMenuItem8.handleClose();
        collapseMenuItem10.handleClose();
        collapseMenuItem11.handleClose();
        collapseMenuItem9.handleClick(evt);
      } else {
        collapseMenuItem9.handleClose();
      }
    },
    menu10Handle: (evt: any) => {
      if (!collapseMenuItem10.anchorEl) {
        collapseMenuItem3.handleClose();
        collapseMenuItem8.handleClose();
        collapseMenuItem9.handleClose();
        collapseMenuItem11.handleClose();
        collapseMenuItem10.handleClick(evt);
      } else {
        collapseMenuItem10.handleClose();
      }
    },
    menu11Handle: (evt: any) => {
      if (!collapseMenuItem11.anchorEl) {
        collapseMenuItem3.handleClose();
        collapseMenuItem8.handleClose();
        collapseMenuItem9.handleClose();
        collapseMenuItem10.handleClose();
        collapseMenuItem11.handleClick(evt);
      } else {
        collapseMenuItem11.handleClose();
      }
    },
  };
};

const adminRegistrationReportMenuList = (
    history: any,
    checkSubMenuPathInLocation: (value: string) => boolean,
    setMobileMenuOpen: (value: boolean) => void
): (
    | {
  id?: string;
  idKey: string;
  label: string;
  navigate: () => void;
  isActiveSubMenu: boolean;
}
    | string
    )[] => [
  'Registration Report',
  {
    idKey: 'nationalReport',
    label: 'GCE/PSLE/iPSLE',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${opAdminRegistrationReport.route}/${nationalReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${admin}/${opAdminRegistrationReport.route}/${nationalReport.route}`
    ),
  },
  {
    idKey: 'nonNationalReport',
    label: 'AEIS/S-AEIS/SPE/SPERS-Sec',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${opAdminRegistrationReport.route}/${nonNationalReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${admin}/${opAdminRegistrationReport.route}/${nonNationalReport.route}`
    ),
  },
  'Others',
  {
    idKey: 'accessArrangementReport',
    label: 'Access Arrangement Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${opsAdminAccessArrangementReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(
        `/${admin}/${opsAdminAccessArrangementReport.route}`
    ),
  },
  {
    idKey: 'appealReport',
    label: 'Appeal Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${opAdminResultsAppeal.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${opAdminResultsAppeal.route}`),
  },
  {
    idKey: 'auditReport',
    label: 'Audit Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${auditReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${auditReport.route}`),
  },
  {
    idKey: 'dataArchivalReport',
    label: 'Data Archival Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${dataArchivalReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${dataArchivalReport.route}`),
  },
  {
    idKey: 'resitReport',
    label: 'Resit Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${oopAdminResitRegisteredExam.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${oopAdminResitRegisteredExam.route}`),
  },
  {
    idKey: 'specialConsiderationReport',
    label: 'Special Consideration Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${specialConsiderationReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${specialConsiderationReport.route}`),
  },
  {
    idKey: 'paymentReport',
    label: 'Payment Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${opAdminPaymentReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${opAdminPaymentReport.route}`),
  },
  {
    idKey: 'notificationReport',
    label: 'Notification Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${notificationReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${notificationReport.route}`),
  },
  {
    idKey: 'transactionLog',
    label: 'Transaction Log',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${transactionLog.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${transactionLog.route}`),
  },
  {
    idKey: 'jobStatusReport',
    label: 'Job Status Report',
    navigate: () => {
      setMobileMenuOpen(false);
      history.push(`/${admin}/${jobStatusReport.route}`);
    },
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${jobStatusReport.route}`),
  },
];

const AdminMenu = ({
                     setMobileMenuOpen,
                   }: {
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    collapseMenuItem3,
    collapseMenuItem8,
    collapseMenuItem9,
    collapseMenuItem10,
    collapseMenuItem11,
    menu3Handle,
    menu8Handle,
    menu9Handle,
    menu10Handle,
    menu11Handle,
  } = useAdminCollapse();

  return (
      <>
        <ApplicationMenuItem
            collapseMenuItem3={collapseMenuItem3}
            menu3Handle={menu3Handle}
            setMobileMenuOpen={setMobileMenuOpen}
        />
        <ReportsMenuItem
            collapseMenuItem8={collapseMenuItem8}
            menu8Handle={menu8Handle}
            setMobileMenuOpen={setMobileMenuOpen}
        />
        <AccountsMenuItem
            collapseMenuItem9={collapseMenuItem9}
            menu9Handle={menu9Handle}
            setMobileMenuOpen={setMobileMenuOpen}
        />
        <SettingMenuItem
            collapseMenuItem10={collapseMenuItem10}
            menu10Handle={menu10Handle}
            setMobileMenuOpen={setMobileMenuOpen}
        />
        <PersonalMenuItem
            collapseMenuItem11={collapseMenuItem11}
            menu11Handle={menu11Handle}
            setMobileMenuOpen={setMobileMenuOpen}
        />
      </>
  );
};

const MobileMenu = ({
                      mobileMenuOpen,
                      setMobileMenuOpen,
                      baseRole,
                    }: {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  baseRole: BaseRole;
}) => (
    <>
      {baseRole && baseRole === 'CANDIDATE' && (
          <CandidateMenu setMobileMenuOpen={setMobileMenuOpen}/>
      )}

      {baseRole && baseRole === 'COORDINATOR' && (
          <CoordinatorMenu setMobileMenuOpen={setMobileMenuOpen}/>
      )}

      {/* <collapseMenuItem label="Statement of Results" navigate={() => {}} /> */}

      {baseRole && baseRole === 'ADMIN' && <AdminMenu setMobileMenuOpen={setMobileMenuOpen}/>}
    </>
);

const ApplicationMenuItem = ({
                               collapseMenuItem3,
                               menu3Handle,
                               setMobileMenuOpen,
                             }: {
  collapseMenuItem3: UseCollapseReturn;
  menu3Handle: (evt: any) => void;
  setMobileMenuOpen: (value: boolean) => void;
}) => {
  const {history, checkMenuPathsInLocation, checkSubMenuPathInLocation} = useMenu();

  return (
      <MenuCollapseItem
          {...collapseMenuItem3}
          handleClick={menu3Handle}
          label="Applications"
          subMap={[
            'National Examination',
            {
              label: 'Appeal',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${oopAdminResultAppealAccess.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(
                  `/${admin}/${oopAdminResultAppealAccess.route}`
              ),
            },
            {
              label: 'Exam Registration',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${uniqueLink.route}/national`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${uniqueLink.route}/national`),
            },
            {
              label: 'Exam Withdrawal',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${withdrawalLink.route}/national`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${withdrawalLink.route}/national`),
            },
            {
              label: 'Resit',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${oopAdminResitApply.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${oopAdminResitApply.route}`),
            },

            'Non-National Examination',
            {
              label: 'Application Review',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${nonNationalExamApplication.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(
                  `/${admin}/${nonNationalExamApplication.route}`
              ),
            },
            {
              label: 'Exam Registration',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${uniqueLink.route}/non-national`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${uniqueLink.route}/non-national`),
            },
            'Results',
            {
              label: 'GCE/PSLE/iPSLE Examination',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${orgAdminResultRelease.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${orgAdminResultRelease.route}`),
            },
            {
              label: 'Non-National Examination',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${orgAdminNonNationalResult.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(
                  `/${admin}/${orgAdminNonNationalResult.route}`
              ),
            },
            'Others',
            {
              label: 'Useful Information',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${usefulInformation.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${usefulInformation.route}`),
            },
            {
              label: 'Manage Announcements',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${manageAnnouncements.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${manageAnnouncements.route}`),
            },
            {
              label: 'Manage Notifications',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${manageNotifications.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${manageNotifications.route}`),
            },
            {
              label: 'Profile Amendment Requests',
              navigate: () => {
                setMobileMenuOpen(false);
                history.push(`/${admin}/${profileAmendmentRequests.route}`);
              },
              isActiveSubMenu: checkSubMenuPathInLocation(
                  `/${admin}/${profileAmendmentRequests.route}`
              ),
            },
          ]}
          isActiveMenu={checkMenuPathsInLocation(adminApplicationsPathDetails)}
      />
  );
};

const ReportsMenuItem = ({
                           collapseMenuItem8,
                           menu8Handle,
                           setMobileMenuOpen,
                         }: {
  collapseMenuItem8: UseCollapseReturn;
  menu8Handle: (evt: any) => void;
  setMobileMenuOpen: (value: boolean) => void;
}) => {
  const {history, checkMenuPathsInLocation, checkSubMenuPathInLocation} = useMenu();

  return (
      <MenuCollapseItem
          {...collapseMenuItem8}
          handleClick={menu8Handle}
          label="Reports"
          subMap={adminRegistrationReportMenuList(
              history,
              checkSubMenuPathInLocation,
              setMobileMenuOpen
          )}
          isActiveMenu={checkMenuPathsInLocation(adminReportsPathDetails)}
      />
  );
};

export default MobileMenu;
